import { render } from "./FormQuestions.vue?vue&type=template&id=605f285e&scoped=true&ts=true"
import script from "./FormQuestions.vue?vue&type=script&lang=ts"
export * from "./FormQuestions.vue?vue&type=script&lang=ts"

import "./FormQuestions.vue?vue&type=style&index=0&id=605f285e&lang=scss"
import "./FormQuestions.vue?vue&type=style&index=1&id=605f285e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605f285e"]])

export default __exports__